import React from 'react';
import {
  CATEGORY4CONSTANTS,
  currencyOptions,
  transportationModeOptions,
} from 'constants/Scope3Constants/category4.constants';
import { FieldType } from 'enums/FieldTypeEnums';
import { TransportationProps } from 'enums/TransportationEnums';
import { Category1TypeFields, Category1Types } from 'enums/category1Enums';
import { FieldsRowProps } from 'shared/components/FieldsRow';
import { TemperatureControl } from 'views/CreateProductFlow/Transportation/TransportationConstants';
import { ReactComponent as Add } from 'assets/icons/add.svg';
import styles from './category4.module.scss';
import {
  allowOnlyNumbersUptoN,
  allowOnlyPercentages,
} from 'shared/utils/convertFormData';
import { CategoryOptions } from 'shared/components/CreateProductModal/ProductModalForm';

interface Category4LayoutDataProps {
  index: number;
  type: Category1Types;
  supplierOptions?: CategoryOptions[];
  disableOwnedVehicles?: boolean;
  openSuppliermodal?: () => void;
}

export const categoryTypeFieldMap = {
  [Category1Types.INGREDIENTS]: Category1TypeFields.INGREDIENTS,
  [Category1Types.PACKAGING_MATERIALS]: Category1TypeFields.PACKAGING_MATERIALS,
  [Category1Types.OTHERS]: Category1TypeFields.OTHERS,
  [Category1Types.FERTILISERS]: Category1TypeFields.FERTILISERS,
};

const {
  LABELS,
  GUTTER_VALUE,
  FIELD_OWNED_VEHICLES,
  FIELD_SUPPLIER,
  FIELD_TEMPERATURE_CONTROL,
  FIELD_TRANSPORTATION_VIA_AIR,
  FIELD_PRIMARY_MODE_OF_TRANSPORT,
  FIELD_TRANSPORTATION_COST,
  FIELD_UNIT,
} = CATEGORY4CONSTANTS;

const {
  SUPPLIER,
  TEMPERATURE_CONTROL,
  OWNED_VEHICLES,
  TRANSPORTATION_VIA_AIR,
  TRANSPORTATION_COST,
  PRIMARY_MODE_OF_TRANSPORT,
  UNIT,
} = LABELS;
export const getFormData = (
  props: Category4LayoutDataProps
): FieldsRowProps => {
  const {
    index,
    type,
    supplierOptions,
    disableOwnedVehicles,
    openSuppliermodal,
  } = props;

  const getName = (name: string) => getFieldName(type, index, name);

  const dropdownRender = (menu: CategoryOptions[]) => {
    return (
      <>
        <div
          className={styles.dropdownCreateButton}
          onClick={openSuppliermodal}>
          <Add /> {TransportationProps.CREATE_SUPPLIER}
        </div>
        {menu}
      </>
    );
  };

  return {
    data: [
      ...(type === Category1Types.OTHERS
        ? [
            {
              type: FieldType.INPUT,
              fieldProps: {
                name: getName(FIELD_TRANSPORTATION_COST),
                label: TRANSPORTATION_COST,
                disabled: !!disableOwnedVehicles,
                placeholderstring: TRANSPORTATION_COST,
                isNullable: true,
                onKeyDown: allowOnlyNumbersUptoN(2),
              },
              span: 3,
            },
            {
              type: FieldType.SELECT,
              fieldProps: {
                name: getName(FIELD_UNIT),
                options: currencyOptions,
                label: UNIT,
                disabled: !!disableOwnedVehicles,
                placeholderstring: UNIT,
              },
              span: 4,
            },
            {
              type: FieldType.SELECT,
              fieldProps: {
                name: getName(FIELD_PRIMARY_MODE_OF_TRANSPORT),
                label: PRIMARY_MODE_OF_TRANSPORT,
                options: transportationModeOptions,
                disabled: !!disableOwnedVehicles,
                placeholderstring: PRIMARY_MODE_OF_TRANSPORT,
              },
              span: 4,
            },
          ]
        : [
            {
              type: FieldType.SELECT,
              fieldProps: {
                name: getName(FIELD_SUPPLIER),
                options: supplierOptions,
                label: SUPPLIER,
                disabled: !!disableOwnedVehicles,
                placeholderstring: SUPPLIER,
                dropdownRender,
              },
              span: 4,
            },
            {
              type: FieldType.SELECT,
              fieldProps: {
                name: getName(FIELD_TEMPERATURE_CONTROL),
                label: TEMPERATURE_CONTROL,
                options: TemperatureControl,
                disabled: !!disableOwnedVehicles,
                placeholderstring: TEMPERATURE_CONTROL,
              },
              span: 4,
            },
          ]),
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: getName(FIELD_OWNED_VEHICLES),
          label: OWNED_VEHICLES,
          disabled: !!disableOwnedVehicles,
          placeholderstring: OWNED_VEHICLES,
          isNullable: true,
          onKeyDown: allowOnlyPercentages,
        },
        span: 3,
      },
      ...(type !== Category1Types.OTHERS
        ? [
            {
              type: FieldType.CHECKBOX,
              fieldProps: {
                name: getName(FIELD_TRANSPORTATION_VIA_AIR),
                label: TRANSPORTATION_VIA_AIR,
                disabled: !!disableOwnedVehicles,
              },
              className: styles.alignCenter,
            },
          ]
        : []),
    ],
    rowGutter: GUTTER_VALUE,
  };
};

export const getFieldName = (
  type: Category1Types,
  index: number,
  fieldName: string
): string => {
  const typeValue = categoryTypeFieldMap[type];
  return `${typeValue}.[${index}].${fieldName}`;
};
